import { alpha, styled } from "@mui/material/styles";
import { motion } from "framer-motion";

export const Wrapper = styled("div")`
  position: fixed;
  right: 20px;
  z-index: 9999999;
`;

export const Container = styled("div")`
  display: flex;
  padding-right: 0.5rem;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Spacer = styled(motion.div)`
  height: 10px;
  min-height: 10px;
  width: 100%;
  display: block;
`;

export const Row = styled("div")`
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ theme }) =>
    alpha(theme.palette.background.default, 0.5)};
  min-width: 200px;
  max-width: 350px;
  width: 100%;
`;

export const ToastStack = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Slide = styled(motion.div)`
  position: relative;
  z-index: 9999999;
  width: 100%;
  will-change: transform, opacity;
  margin-bottom: 0;

  &:first-child {
    z-index: 10000000;
  }
`;
